import { ApiResponse } from '@marketplace-web/shared/api-client'

import { api } from 'data/api/api'

import { SaveShippingOrderContactArgs } from '../types/shipping-contact'

export const saveShippingOrderContact = (args: SaveShippingOrderContactArgs) =>
  api.post<ApiResponse>(`/shipping_orders/${args.shippingOrderId}/shipping_contact`, {
    save_for_later: args.saveForLater,
    receiver_phone_number: args.receiverPhoneNumber,
    sender_phone_number: args.senderPhoneNumber,
    phone_number: args.phoneNumber,
  })
